export const CHANNEL_TYPE = {
  CRYPTO: 'crypto',
  FM: 'finance-magnates'
}
